<template>
  <div>
    <el-carousel height="44.27vw" :autoplay="false">
      <el-carousel-item v-for="(ad, index) in ads" :key="index">
        <div :style="'background-image:url(' + ad.imgUrl + ')'" class="ad-img"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    name: 'AdsPanel',

    data () {
      return {
        ads: [
          {
            imgUrl: require('../assets/images/banner1.jpg')
          },
          {
            imgUrl: require('../assets/images/banner2.jpg')
          },
          {
            imgUrl: require('../assets/images/banner3.jpg')
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .ad-img {
    background-size: cover;
    background-position: center;
    width: 100vw;
    height: 44.27vw;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdsPanel.vue